import type { RouteLocationNormalizedLoaded } from 'vue-router';

/**
 * Brand label a route is on. The one reader of the brand route param, so moving the brand out of
 * the path changes only this file (docs/planning/brand-routing.md). Outside routing code, read the
 * brand from `useActiveBrand()` instead.
 */
export function getRouteBrandLabel(
  route: Pick<RouteLocationNormalizedLoaded, 'params'> | null | undefined,
): string | undefined {
  const label = route?.params?.brandLabel;
  return typeof label === 'string' ? label : undefined;
}
